module.exports = __webpack_public_path__ + "static/media/planet.1791a3a0.svg";